import Index from './index.vue'
import Create from './components/Create.vue'
import List from './components/List.vue'
// import Edit from './components/Edit.vue'

export default [
  {
    path: 'purchase',
    name: 'purchase',
    component: Index,
    title: 'Purchase',
    redirect: { name: 'purchase-list' },
    children: [
      {
        path: 'create',
        name: 'purchase-create',
        component: Create,
      },
      {
        path: 'list',
        name: 'purchase-list',
        component: List,
      },
      // {
      //   path: 'edit',
      //   name: 'pruchase-edit',
      //   component: Edit,
      // },
    ],
  },
]
